<template>
    <div id="page">
        <div class="page-content">

            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ارجاع {{lableText('TaskName')??'وظیفه'}}</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <!--<div class="row mb-0 px-3">
                <div class="col-6 px-1">
                    <task-folder-list></task-folder-list>
                    <button class="btn btn-full btn-xxs rounded-s bg-magenta2-light font-900 mb-3 text-white w-100" @click.prevent="copyFromParent">کپی از وظیفه ارجاع شده</button>
                </div>
            </div>-->
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">
                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check-square brand-color"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : taskModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="taskModel.title" @input="v$.taskModel.title.$touch()" :class="{invalid:v$.taskModel.title.$error}">
                        <p class="text-danger" v-if="v$.taskModel.title.required.$invalid && v$.taskModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>

                    <div class="mb-4">
                        <v-select :class="{invalid:v$.taskModel.receiverUserId.$error}" dir="rtl" label="title" placeholder="ارجاع گیرنده" :filterable="true" :options="localUserListList" :reduce="p => p.userId" v-model="taskModel.receiverUserId">
                            <template slot="option">
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                        <p class="text-danger" v-if="v$.taskModel.receiverUserId.required.$invalid && v$.taskModel.receiverUserId.$dirty">لطفا ارجاع گیرنده را انتخاب کنید.</p>

                    </div>
                    <div class="mb-4">
                        <preferenceTypeList txtPlaceholder="ضرورت" class="mb-3" @selectPreferenceType="selectPreferenceType"></preferenceTypeList>
                    </div>

                    <div class="mb-4">
                        <v-select :class="{invalid:v$.taskModel.priorityId.$error}" dir="rtl" label="title" placeholder="اولویت" :filterable="true" :options="priorityList" :reduce="p => p.priorityId" v-model="taskModel.priorityId">
                            <template slot="option">
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                        <p class="text-danger" v-if="v$.taskModel.priorityId.required.$invalid && v$.taskModel.priorityId.$dirty">لطفا اولویت را وارد کنید.</p>
                    </div>

                    <div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-calendar-check brand-color"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : taskModel.startDateTime!==null}">تاریخ و ساعت شروع</span>
                            <input type="text"
                                   class="form-control ltr d-inline-block"
                                   v-model="taskModel.startDateTime"
                                   id="startDT"
                                   :class="{invalid:v$.taskModel.startDateTime.$error}" />
                        </div>
                        <p class="text-danger" v-if="v$.taskModel.startDateTime.required.$invalid && v$.taskModel.startDateTime.$dirty">لطفا تاریخ و ساعت شروع را وارد کنید.</p>
                    </div>

                    <div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-calendar-times brand-color"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : taskModel.endDateTime!==null}">تاریخ و ساعت پایان</span>
                            <input type="text"
                                   class="form-control ltr d-inline-block"
                                   v-model="taskModel.endDateTime"
                                   id="endDT"
                                   :class="{invalid:v$.taskModel.endDateTime.$error}" />
                        </div>
                        <p class="text-danger" v-if="v$.taskModel.endDateTime.required.$invalid && v$.taskModel.endDateTime.$dirty">لطفا تاریخ و ساعت پایان را وارد کنید.</p>

                    </div>

                    <div class="mb-4">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-clock pl-2 brand-color"></i>
                                <label class="mb-0 font-12 font-weight-bold">زمان معین شده</label>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="d-flex justify-content-between align-items-center">
                                    <label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
                                    <span class="font-13 font-weight-bold px-3"></span>
                                    <label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
                                </div>
                                <div class="ltr">
                                    <input placeholder="00" class="form-control ltr d-inline-block text-center" style="max-width:70px" type="tel" v-model="taskModel.suggestPersonTimeHour" @change="saveHeader" @input="v$.taskModel.suggestPersonTimeHour.$touch()" :class="{invalid:v$.taskModel.suggestPersonTimeHour.$error}">
                                    <span class="font-13 font-weight-bold px-3">:</span>
                                    <input placeholder="00" class="form-control ltr d-inline-block text-center" style="max-width:70px" type="tel" v-model="taskModel.suggestPersonTimeMinute" @change="saveHeader" @input="v$.taskModel.suggestPersonTimeMinute.$touch()" :class="{invalid:v$.taskModel.suggestPersonTimeMinute.$error}">
                                </div>
                            </div>
                        </div>
                        <p class="text-danger mt-2" v-if="v$.taskModel.suggestPersonTimeHour.between.$invalid && v$.taskModel.suggestPersonTimeHour.$dirty">ساعت باید مقداری از ۰ تا ۱۰۰۰ داشته باشد.</p>
                        <p class="text-danger mt-2" v-if="v$.taskModel.suggestPersonTimeMinute.between.$invalid && v$.taskModel.suggestPersonTimeMinute.$dirty">دقیقه باید مقداری از ۰ تا ۵۹ داشته باشد.</p>
                        <p class="text-danger " v-if="v$.taskModel.suggestedPersonTime.required.$invalid && v$.taskModel.suggestedPersonTime.$dirty">لطفا زمان معین شده را وارد کنید.</p>

                    </div>

                    <div class="mb-3">
                        <textarea v-model="taskModel.description" class="form-control line-height-m text-justify" rows="3" style="height:200px" @input="v$.taskModel.description.$touch()" :class="{invalid:v$.taskModel.description.$error}" placeholder="توضیحات"></textarea>
                        <p class="text-danger" v-if="v$.taskModel.description.required.$invalid && v$.taskModel.description.$dirty">لطفا توضیحات را وارد کنید.</p>
                    </div>


                    <att-list :docId="0" v-bind:destination="'TaskFolder'" @setAttList="SetAttList($event)" :canAdd="true" :canDelete="true" :oldAttList="[]"></att-list>


                    <button :disabled="Loading" class="btn btn-xxs mt-2 mb-3 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateTaskFolder">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <date-picker type="datetime" v-model="taskModel.startDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="startDT" :jumpMinute="5" />
        <date-picker type="datetime" v-model="taskModel.endDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="endDT" :jumpMinute="5" />

        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید...</div>
            </div>
        </transition>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">
                <button @click.prevent="copyFromParent" class="btn btn-link">
                    <div class="icon icon-m rounded-m color-white bg-green2-light">
                        <i class="fa fa-copy"></i>
                    </div>
                </button>
            </div>
        </transition>
    </div>
</template>
<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required, between
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'
    import AttList from '../Components/AttList.vue';
    import PreferenceType from '../Components/PreferenceTypeList.vue';
    import DatePicker from 'vue3-persian-datetime-picker';

    export default {
        components: {
            "preferenceTypeList": PreferenceType,
            DatePicker,
            "att-list": AttList
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                taskModel: {
                    taskId: this.$route.params.taskId,
                    parentTaskFolderId: this.$route.params.taskFolderId,
                    title: null,
                    receiverUserId: null,
                    priorityId: null,
                    suggestedPersonTime: "",
                    startDateTime: this.$store.getters.GetServerDateTime,
                    startTime: null,
                    endDateTime: null,
                    endTime: null,
                    description: null,
                    attList: [],
                    suggestPersonTimeHour: null,
                    suggestPersonTimeMinute: null,


                    preferenceTypeTitle: "",
                    preferenceTypeId: null
                },
                pageLoaded: false

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            priorityList() {
                return this.$store.getters.GetPriorityList;
            },
            taskTypeList() {
                return this.$store.getters.GetTaskTypeList;
            },
            localUserListList() {
                return this.$store.getters.GetLocalUserListList;
            },
            workGroupList() {
                return this.$store.getters.GetWorkGroupList;
            }
        },
        created() {
            this.$store.dispatch("GetPriorityListFromServer");
            this.getUserList();
            this.$store.dispatch("GetServerDateTimeFromServer");
            this.getServerDateTime();
        },


        methods: {
            selectPreferenceType(d) {
                this.taskModel.preferenceTypeId = d;
            },
            showAddButton() {
                this.pageLoaded = true;
                var x = screen.height;
                var topForAddButton = x - 220 + 'px';
                this.$refs.addBtn.style.top = topForAddButton;
            },
            CreateTaskFolder() {
                this.taskModel.suggestedPersonTime = this.taskModel.suggestPersonTimeHour + this.taskModel.suggestPersonTimeMinute;
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.$store.dispatch("CreateTaskFolder", this.taskModel);
                }

            },
            getUserList() {
                this.taskModel.receiverUserId = null;
                this.$store.dispatch("GetLocalUserListListFromServer", {
                    workGroupId: this.taskModel.workGroupId,
                    expiredControl: true
                });
            },
            getServerDateTime() {
                this.$http.get("Task/GetServerDateTime")
                    .then(data => {
                        this.taskModel.startDateTime = data.data.replace('_', " ");
                    });

            },
            copyFromParent() {
                this.$http.get("Task/EidtTask?taskId=" + this.taskModel.taskId + "&taskFolderId=" + this.taskModel.parentTaskFolderId + "&plainDesc=true")
                    .then(data => {
                        this.taskModel.description = data.data.description;
                        this.taskModel.priorityId = data.data.priorityId;
                        this.taskModel.suggestedPersonTime = data.data.suggestedPersonTime;
                        this.taskModel.suggestPersonTimeHour = data.data.suggestPersonTimeHour;
                        this.taskModel.suggestPersonTimeMinute = data.data.suggestPersonTimeMinute;
                        this.taskModel.startDateTime = data.data.startDateTime;
                        this.taskModel.title = data.data.title;
                    });
            },
            fixTime() {

                var val = this.taskModel.suggestedPersonTime;
                if (val.length == 1) {
                    val = '0' + val + ':00';
                }
                else if (val.length == 2) {
                    val = val + ':00';
                }
                else if (val.length == 3) {
                    val = val + '00';
                }
                else if (val.length == 4) {
                    val = val + '0';
                }
                this.taskModel.suggestedPersonTime = val;
            },
            SetAttList(e) {
                console.log(e);
                this.taskModel.attList = e;
            }
        },

        validations: {
            taskModel: {
                title: {
                    required
                },
                priorityId: {
                    required
                },
                receiverUserId: {
                    required
                },
                suggestedPersonTime: {
                    required
                },
                startDateTime: {
                    required
                },
                endDateTime: {
                    required
                },
                description: {
                    required
                },
                suggestPersonTimeHour: {
                    between: between(0, 1000)
                },
                suggestPersonTimeMinute: {
                    between: between(0, 59)
                },
            }


        },
        directives: { maska },
        mounted() {
            console.log("mounted");
            this.showAddButton();
        }

    };
</script>
